<template>
    <a :href="'mailto:' + mailToEmail" @click.prevent="openMailTo" v-html="displayEmail" :class="colorString ? 'text-' + colorString : ''" :style="{color: colorHex}"/>
</template>

<script>
import Colorable from "../../mixins/Colorable";

    export default {

        name: 'Email',

        mixins: [Colorable],

        props: {

            // The email to display in the link
            email: {
                type: String,
                required: true
            }
        },

        computed: {

            // The email that gets displayed. We insert hidden elements between the email address to irritate the spam bots.
            displayEmail() {

                // When other content is specified, we show that content and not the specified email address
                if (this.$slots.default) {
                    return null;
                }
                let email = this.email;

                if (!email) {
                    return null;
                }

                let parts = email.split('@');

                return parts[0] + '<span class="none">HIDDEN</span>@' + '<span class="none">HIDDEN</span>' + parts[1];
            },

            // The email that gets inserted in the mail to reference. We replace the '@' and '.' with strings so spam bots
            // will not recognize the email
            mailToEmail() {
                let email = this.email;

                if (!email) {
                    return null;
                }

                return email.replace('@', 'AT').replace('.', 'DOT');
            }
        },

        methods: {

            /**
             * Reset the 'mailTo' email address when the user clicks on the link.
             */
            openMailTo() {
                window.location.href = 'mailto:' + this.email;
            }
        }
    }
</script>